import { useEffect, useState } from "react";
import styles from "./CartItemOptions.module.scss";
import { currency } from "config";

export default function CartItemOptions({ options, openModal }) {
  const [itemOptions, setItemOptions] = useState([]);
  useEffect(() => {
    const newItemOptions = options.map((option) => {
      return (
        <ItemOption option={option} key={option.id} openModal={openModal} />
      );
    });

    setItemOptions(newItemOptions);
  }, [options, openModal]);

  return <div className={`${styles.options}`}>{itemOptions}</div>;
}

export function ItemOption({ option, openModal }) {
  const handleOptionClick = () => {
    openModal();
  };

  return (
    <div className={`${styles.option}`}>
      <label className={`${styles.optionLabel}`}>{option.label}</label>
      {option?.mode !== "static" && (
        <button className={`${styles.optionValue}`} onClick={handleOptionClick}>
          {option.value}
        </button>
      )}
      {option?.mode === "static" && (
        <span className={`${styles.optionValue} ${styles.static}`}>
          {currency.symbol}
          {option.initialValue}
        </span>
      )}
    </div>
  );
}
